import React, { useEffect, useState } from 'react'
import { MultiSelect } from 'react-multi-select-component'
import SelectCloseIcon from '../../assets/select-close-icon.svg'
import ArrowDropDown from '../../assets/Content-Icons/dropdown'

const CustomMultiSelect = ({
  optionsData,
  selectedValue,
  onChange,
  labelKey,
  valueKey = '_id',
  disabled,
}) => {
  const [options, setOptions] = useState([])
  const [multiSelectValue, setMultiSelectValue] = useState([])

  useEffect(() => {
    setOptions(optionsData.map((info) => ({ label: info[labelKey], value: info[valueKey] })))
  }, [optionsData])

  useEffect(() => {
    setMultiSelectValue(
      selectedValue.map((info) => ({ label: info[labelKey], value: info[valueKey] })),
    )
  }, [selectedValue])

  const handleSetData = (selected) => {
    setMultiSelectValue(selected)
    let tempArr = []
    for (let index = 0; index < selected.length; index++) {
      const id = selected[index]?.value
      let tempObj = optionsData.find((obj) => obj[valueKey] === id)
      if (tempObj) {
        tempArr.push(tempObj)
      }
    }
    onChange(tempArr)
  }

  const valueRenderer = (selected) => {
    if (!selected.length) {
      return <p className="mt-3">Select...</p>
    }

    return selected.map((info) => (
      <button
        key={info.label}
        style={{
          borderRadius: '15px',
          backgroundColor: disabled ? '#8b8b8b' : '#000',
          color: 'white',
          fontSize: '12px',
        }}
        className="mx-1 pl-2 pr-0 border-0 "
        disabled={disabled}
      >
        <div className=" d-flex justify-content-center align-items-center">
          {info.label}
          <img
            src={SelectCloseIcon}
            style={{ width: '14px', height: '14px' }}
            alt="SelectCloseIcon"
            className="mx-1 "
            onClick={
              disabled
                ? null
                : () => handleSetData(selected.filter((ele) => ele.value !== info.value))
            }
          />
        </div>
      </button>
    ))
  }

  const DefaultItemRenderer = ({ checked, option, onClick, disabled }) => {
    return (
      <div
        className={`item-renderer ${disabled ? 'disabled' : ''} d-flex align-items-center`}
        style={{
          borderBottom:
            option.label === 'Select All' && option.value === '' ? '0.5px solid #707070' : '',
        }}
      >
        <input
          type="checkbox"
          onChange={onClick}
          checked={checked}
          tabIndex={-1}
          disabled={disabled}
          style={{ accentColor: '#000' }}
        />
        <span style={{ fontSize: '15px' }}>{option.label}</span>
      </div>
    )
  }
  return (
    <MultiSelect
      options={options}
      valueRenderer={valueRenderer}
      ItemRenderer={DefaultItemRenderer}
      value={multiSelectValue}
      onChange={handleSetData}
      ArrowRenderer={ArrowDropDown}
      disabled={disabled}
    />
  )
}

export default CustomMultiSelect
